import vue from "vue";
import vuex from "vuex";
vue.use(vuex);

import tourism from './fastTrack'
import profile from '../../profile/store/profile'
import dolphin from "./dolphin";
import club from '../../club/store/club'

export default new vuex.Store({
  modules: {
    tourism,
    profile,
    dolphin,
    club,
  },
});
